import { FindOneRepositoryResponseDto } from 'app/API';
import { EACCEPTED_AUDIO_FORMATS } from 'app/types/enums/EACCEPTED_AUDIO_FORMATS';
import { EACCEPTED_DOCUMENT_FORMATS } from 'app/types/enums/EACCEPTED_DOCUMENT_FORMATS';
import { TForm } from '../components/blocks/MainBlock';

const getExtension = (fileName: string) => `.${fileName.split('.').pop()?.toLowerCase()}`;

export const buildRepositoryForm = (repository: FindOneRepositoryResponseDto): TForm => {
  const attachments = repository.Attachments ?? [];

  return {
    name: repository.name,
    slug: repository.slug,
    notes: repository.notes ?? '',
    assignee: repository.Assignee,
    audioFiles: attachments.filter((file) => EACCEPTED_AUDIO_FORMATS.includes(getExtension(file.fileName))),
    documentFiles: attachments.filter((file) => EACCEPTED_DOCUMENT_FORMATS.includes(getExtension(file.fileName))),
  };
};
